export function numberText(text: string) {
  if (isNaN(Number(text))) {
    return text;
  }
  return `${[...text]
    .reverse()
    .reduce(
      (acc, cur, i) => (i && i % 3 === 0 ? `${cur},${acc}` : `${cur}${acc}`),
      "",
    )}`;
}

export function getParameterObject({ url }: { url: string }) {
  const params = url.split("?")[1]?.split("&") || [];
  const obj: { [key: string]: string } = {};

  for (let i = 0; i < params.length; i++) {
    const temp = params[i]?.split("=") || [];
    const key = temp[0];
    const value = temp.splice(1, temp.length).join("=");
    obj[key] = value;
  }
  return obj;
}

export function getParameter({ url, key }: { url: string; key: string }) {
  const obj = getParameterObject({ url });
  return obj[key];
}

export function isAndroid() {
  return /Android/i.test(navigator.userAgent);
}

export function isIos() {
  const userAgent = navigator.userAgent;
  const isMobileSize = window.innerWidth <= 400;

  const isIosDevice = /iPhone|iPad|iPod/.test(userAgent);
  const isMacOs = /Macintosh|Mac OS X/.test(userAgent);

  return isIosDevice || (isMobileSize && isMacOs);
}

export function formatStringToDate({
  date,
  delimiter = ".",
}: {
  date: string;
  delimiter?: string;
}) {
  const digits = date.replace(/\D/g, "").substring(0, 8);

  let formatted = digits;
  if (digits.length >= 7) {
    formatted =
      digits.substring(0, 4) +
      delimiter +
      digits.substring(4, 6) +
      delimiter +
      digits.substring(6);
  } else if (digits.length >= 5) {
    formatted = digits.substring(0, 4) + "." + digits.substring(4);
  }
  return formatted;
}

export function isDefined<T>(argument: T | undefined | null): argument is T {
  return argument !== undefined && argument !== null;
}
